import { FC, PropsWithChildren, useEffect } from "react";
import KickImage from 'Reuseables/KickImage';
import { Modal } from "react-bootstrap";
import { toast } from 'react-toastify';

//Components
import ModalTopLevel from "../../ModalTopLevel"
import { LoadingIcon } from "../../../atomic"

import ArrowBack from "../../../../images/black-mii-left.png";

//Interface
import { CustomBodyInterface } from "./definitions";

const CustomBody: FC<PropsWithChildren<CustomBodyInterface>> = ({
  withBack,
  className,
  loading,
  children,
  toastMessage,
  resetToast,
  backAction
}): JSX.Element => {

  useEffect(() => {
    if (toastMessage) {
      toast.error(
        toastMessage,
        {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          onClose: () => resetToast && resetToast()
        },
      );
    }
  }, [toastMessage])

  return <Modal.Body className={`custom-body ${withBack ? "with-back" : ""} ${className}`}>
    {
      withBack ?
        (<div className="pickup-address-wrapper">
          <KickImage onClick={() => backAction && backAction()} className="back" src={ArrowBack} alt="back" />
        </div>)
        : null
    }
    {children}

    {
      loading ?
        (
          <ModalTopLevel onHide={() => null} show={true}>
            <LoadingIcon />
          </ModalTopLevel>
        )
        : null
    }

  </Modal.Body>
}

CustomBody.defaultProps = {
  withBack: false,
  loading: false,
  backAction: () => { },
  className: "",
  children: <div />
}

export default CustomBody;
